import React from 'react';
import UploadStatus from './components/UploadStatus';
import CellWithErrorMessages from './components/CellWithErrorMessages';
import CellWithDash from './components/CellWithDash';
import { CellData } from './types';
import { VirtualizedTableColumn } from './components/VirtualizedTable';

export const virtualizedTableColumns = (): VirtualizedTableColumn[] => {
  return [
    {
      label: '생성 가능 여부',
      dataKey: 'isValid',
      width: 105,
      render: (data: boolean) => <UploadStatus status={data} />,
    },
    {
      label: '브랜드 ID',
      dataKey: 'brandId',
      width: 80,
      render: (data: CellData) => <CellWithDash {...data} />,
    },
    {
      label: '브랜드명',
      dataKey: 'brandName',
      width: 200,
      render: (data: CellData) => <CellWithErrorMessages {...data} />,
    },
    {
      label: '상품 ID',
      dataKey: 'productId',
      width: 200,
      render: (data: CellData) => <CellWithErrorMessages {...data} />,
    },
    {
      label: '상품명',
      dataKey: 'productName',
      width: 400,
      render: (data: CellData) => <CellWithDash {...data} />,
    },
    {
      label: '옵션 ID',
      dataKey: 'productOptionId',
      width: 200,
      render: (data: CellData) => <CellWithErrorMessages {...data} />,
    },
    {
      label: '옵션명',
      dataKey: 'productOptionName',
      width: 350,
      render: (data: CellData) => <CellWithDash {...data} />,
    },
    {
      label: '수량',
      dataKey: 'quantity',
      width: 150,
      render: (data: CellData) => <CellWithErrorMessages {...data} />,
    },
    {
      label: '판매처',
      dataKey: 'multiChannelName',
      width: 150,
      render: (data: CellData) => <CellWithErrorMessages {...data} />,
    },
    {
      label: '바코드',
      dataKey: 'productOptionBarcode',
      width: 135,
      render: (data: CellData) => <CellWithDash {...data} />,
    },
    {
      label: '외부주문관리번호',
      dataKey: 'externalOrderId',
      width: 165,
      render: (data: CellData) => <CellWithErrorMessages {...data} />,
    },
    {
      label: '주문 메시지',
      dataKey: 'message',
      width: 400,
      render: (data: CellData) => <CellWithErrorMessages {...data} />,
    },
    {
      label: '수취인',
      dataKey: 'recipient',
      width: 400,
      render: (data: CellData) => <CellWithErrorMessages {...data} />,
    },
    {
      label: '수취인 연락처',
      dataKey: 'cellPhone',
      width: 500,
      render: (data: CellData) => <CellWithErrorMessages {...data} />,
    },
    {
      label: '배송지',
      dataKey: 'address',
      width: 600,
      render: (data: CellData) => <CellWithErrorMessages {...data} />,
    },
    {
      label: '우편번호',
      dataKey: 'postCode',
      width: 400,
      render: (data: CellData) => <CellWithErrorMessages {...data} />,
    },
  ];
};
